import React from 'react';
import AppRoutes from './router/AppRoutes';

export default function AppRoot() {
  return <AppRoutes />;
}
